<div class="container message-container">
    <div class="row message-row">
        <div class="col message-col">
            <label>{{ message }}</label>
        </div>
    </div>
</div>
<div class="arrow"></div>
